import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Spinner } from "@/components/ui/spinner";
import { useTeamMembers } from "../hooks";
import { useTeamManagementUIStore } from "../store/use-team-management-ui-store";

export function TeamMemberDeleteDialog() {
  const { isDeleteDialogOpen, deletingMemberId, closeDeleteDialog } = useTeamManagementUIStore();

  const { deleteMember, deleting, teamMembers } = useTeamMembers();

  // Find the member being deleted
  const memberToDelete = teamMembers.find((m) => m.id === deletingMemberId);

  const handleDelete = async () => {
    if (!deletingMemberId) return;

    try {
      await deleteMember(deletingMemberId);
      closeDeleteDialog();
    } catch (error) {
      // Error is handled by the mutation hook
      console.error("Failed to delete team member:", error);
    }
  };

  const handleCancel = () => {
    if (!deleting) {
      closeDeleteDialog();
    }
  };

  return (
    <AlertDialog open={isDeleteDialogOpen} onOpenChange={handleCancel}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Delete Team Member</AlertDialogTitle>
          <AlertDialogDescription className="space-y-2">
            <p>
              Are you sure you want to delete{" "}
              <span className="font-semibold">{memberToDelete?.worker?.displayName}</span>?
            </p>
            <p className="text-sm text-muted-foreground">
              This action cannot be undone. The team member will be permanently removed from your
              salon, along with their schedule and appointment history.
            </p>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={deleting}>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={handleDelete}
            disabled={deleting}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
          >
            {deleting && <Spinner className="w-4 h-4 mr-2" />}
            Delete Member
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
